import {Image} from '@logistics-frontend/blocks/image'
import React from 'react'

import {tagToUrl} from 'src/shared/utils'

type Props = {
  tag: string
}

export const AutoBannerImage: React.FC<Props> = ({tag}) => (
  <Image alt={tag} src={tagToUrl(tag)} width={90} />
)
